import React from 'react';
import { LinearProgress } from '@mui/material';

import Page from '../../components/Page';
import './_loadPage.scss';

const LoadPage = () => (
  <Page className="load-page">
    <LinearProgress />
  </Page>
);

export default LoadPage;
